import styled from 'styled-components';

import WindowRatioDefaultIcon from '../../../../../themes/svg/windowRatioDefaultIcon';
import WindowDimensionsVisualizer from '../WindowDimensionsVisualizer';

export const CenteredWindowRatioDefaultIcon = styled(WindowRatioDefaultIcon)`
align-self: center;
`;
export const CenteredWindowDimensionsVisualizer = styled(WindowDimensionsVisualizer)`
align-self: center;
`;

const headerLabelSize = 25;
export const HeaderLabel = styled.div`
width: ${headerLabelSize}px;
height: ${headerLabelSize}px;
min-width: ${headerLabelSize}px;
min-height: ${headerLabelSize}px;
border-radius: 50%;
background-color: ${props => props.theme.color.bgItemLabel};
color: ${props => props.theme.color.fgItemLabel};
display: flex;
justify-content: center;
align-items: center;
margin: 14px;
margin-left: 0;
flex: 0 0 auto;
`;

export const HeaderName = styled.div`
color: black;
overflow: hidden;
text-overflow: ellipsis;
`;

export const HeaderEdit = styled.div`
margin-left: 14px;

.link {
  color: ${({ theme }) => theme.color.link};
  cursor: pointer;
  background: transparent;
  border: transparent;
  outline: none;
}
`;

export const ItemHeader = styled.div`
display: flex;
align-items: center;
padding: 0 14px;
`;
